<div class="powered-by-carepay py-3 px-4 d-flex justify-content-center align-items-center">
  <span class="me-1">Powered by</span>
  <img class="ms-1" [attr.src]="poweredBySrc" alt="powered by" />
</div>
